/**
 * Minutes → compact human duration for SLA downtime / response / resolution
 * times. `0 → "0m"`, `80 → "1h 20m"`, `1500 → "1d 1h"`. Mirrors the legacy
 * ManageSLA `formatDuration` output.
 */
export function formatDuration(minutes?: number | null): string {
  if (minutes == null || !isFinite(minutes) || minutes <= 0) return '0m';
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours < 24) return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
  const days = Math.floor(hours / 24);
  const remHours = hours % 24;
  return remHours > 0 ? `${days}d ${remHours}h` : `${days}d`;
}
